import type { SalesCheckinRootState } from '../common/types/SalesCheckinRootState';

export const getFinancingInitialTab = (state: SalesCheckinRootState): 'buyer' | 'insurance' =>
    state.salesCheckin?.financing?.initialTab ?? 'buyer';
